import "antd/dist/antd.css";
import {
  //useContractLoader,
  useUserProviderAndSigner,
} from "eth-hooks";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "antd";
/*
import {
  Route,
  Switch,
  useLocation
} from "react-router-dom";*/
import { Header } from "./components";
import { NETWORKS } from "./constants";
import {
  Web3ModalSetup,
  //Transactor,
} from "./helpers";
import UrlInput from './components/UrlInput';
import { HARVESTOOOR_ABI } from './contracts/external_contracts';

import "./App.scss";

const { ethers } = require("ethers");

// 📡 What chain are your contracts deployed to?
const initialNetwork = NETWORKS.mainnet; // <------- select your target frontend network (localhost, rinkeby, xdai, mainnet)

// 😬 Sorry for all the console logging
const DEBUG = false;

let web3Modal;

function App(props) {
  // specify all the chains your app is available on. Eg: ['localhost', 'mainnet', ...otherNetworks ]
  // reference './constants.js' for other networks
  const networkOptions = [initialNetwork.name, "mainnet", "rinkeby"];

  const [injectedProvider, setInjectedProvider] = useState();
  const [address, setAddress] = useState();
  //const [writeContracts, setWriteContracts] = useState({});
  const selectedNetwork = networkOptions[0];
  //const location = useLocation();

  const targetNetwork = NETWORKS[selectedNetwork];

  // 🔭 block explorer URL
  const blockExplorer = targetNetwork.blockExplorer;

  if (DEBUG) console.log(`Using ${selectedNetwork} network`);

  const logoutOffWeb3Modal = async () => {
    await web3Modal.clearCachedProvider();
    if (injectedProvider && injectedProvider.provider && typeof injectedProvider.provider.disconnect == "function") {
      await injectedProvider.provider.disconnect();
    }
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  // Use your injected provider from 🦊 Metamask or if you don't have it then instantly generate a 🔥 burner wallet.
  const userProviderAndSigner = useUserProviderAndSigner(injectedProvider);  
  const userSigner = userProviderAndSigner.signer;

  useEffect(() => {
    async function getAddress() {
      if (userSigner) {
        const newAddress = await userSigner.getAddress();
        setAddress(newAddress);
      }
    }
    getAddress();
  }, [userSigner]);

  // You can warn the user if you would like them to be on a specific network
  //const localChainId = localProvider && localProvider._network && localProvider._network.chainId;
  const selectedChainId =
    userSigner && userSigner.provider && userSigner.provider._network && userSigner.provider._network.chainId;

  const harvestooor = new ethers.Contract("0xd60e94434310381575c5e67bb1d3e125133ad3ed", HARVESTOOOR_ABI, userSigner);

  //
  // 🧫 DEBUG 👨🏻‍🔬
  //
  useEffect(() => {
    if (
      DEBUG &&
      address &&
      selectedChainId
    ) {
      console.log("_____________________________________ 🏗 scaffold-eth _____________________________________");
      //console.log("🏠 localChainId", localChainId);
      console.log("👩‍💼 selected address:", address);
      console.log("🕵🏻‍♂️ selectedChainId:", selectedChainId);
    }
  }, [
    address,
    selectedChainId,
    //localChainId,
  ]);

  const loadWeb3Modal = useCallback(async () => {
    const provider = await web3Modal.connect();
    setInjectedProvider(new ethers.providers.Web3Provider(provider));

    provider.on("chainChanged", chainId => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    provider.on("accountsChanged", () => {
      setInjectedProvider(new ethers.providers.Web3Provider(provider));
    });

    // Subscribe to session disconnection
    provider.on("disconnect", (code, reason) => {
      logoutOffWeb3Modal();
    });
    // eslint-disable-next-line
  }, [setInjectedProvider]);

  useEffect(() => {
    if(!web3Modal) {
      web3Modal = Web3ModalSetup()
    }
    if (web3Modal.cachedProvider) {
      loadWeb3Modal();
    }
  }, [loadWeb3Modal]);

  const handleSubmit = async (nfts) => {
    const value = ethers.BigNumber.from("10000000000").mul(nfts.length);
    const argArray = nfts.map(nft => [nft.address, nft.tokenId]);
    const tx = await harvestooor.repurchaseTokens(argArray, { value: value });
    await tx.wait();
  };

  return (
    <div className="App">
      <div className="container">
        <Header
          address={address}
          userSigner={userSigner}
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOffWeb3Modal}
          blockExplorer={blockExplorer}
        />
        <div className="content center">
          
          <hr/>

          <p>If you sold an NFT to <a href="https://nftlossharvestooor.com/app" target="_blank" rel="noreferrer">NFT Loss Harvestooor</a> you can <a href="https://etherscan.io/address/0xd60e94434310381575c5e67bb1d3e125133ad3ed#code#F10#L121" target="_blank" rel="noreferrer">repurchase it</a> for the price you paid.</p>
          <p>The official Harvestooor dapp doesn't have a UI to let you do this, but you can use this one instead.</p>
          <p class="warning">Note that if you rebuy your NFTs, <a href="https://twitter.com/CoinLedger/status/1610205682778918915" target="_blank" rel="noreferrer">you might not be able to claim a loss on your taxes</a>. Be sure to consult a tax professional.</p>

          { address &&
            <div>
              <p>Enter an OpenSea, LooksRare, or X2Y2 URL for any NFT you'd like to repurchase:</p>
              <UrlInput
                onSubmit={handleSubmit}
                userAddress={address}
                userSigner={userSigner}
                harvestooor={harvestooor}
              />
            </div>
          }
          { !address &&
            <Button
              shape="round"
              size="medium"
              type="primary"
              onClick={loadWeb3Modal}
            >
              Connect
            </Button>
          }

          <hr/>

          <div className="credits">
            <p className="center">Built with 💚 for verified contracts by <a href="https://twitter.com/MikeSylphDapps" target="_blank" rel="noreferrer">mike.sylphdapps.eth</a>.</p>
            <p className="center">If you appreciate this, consider minting a <a href="https://sylphdapps.com/phrumps/" target="_blank" rel="noreferrer">Phrump</a>.</p>
            <p className="center">You can see my other work at <a href="https://sylphdapps.com" target="_blank" rel="noreferrer">Sylph Dapps</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
